import React, { SVGProps } from 'react';

const SubAccount = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={18}
    fill="none"
    {...props}
    data-palette="SubAccount">
    <path
      fill="var(--dropdownIconColor)"
      d="M6 10.5V12a4.5 4.5 0 0 0-4.5 4.5H0a6 6 0 0 1 6-6zm0-.75a4.499 4.499 0 0 1-4.5-4.5C1.5 2.764 3.514.75 6 .75s4.5 2.014 4.5 4.5-2.014 4.5-4.5 4.5zm0-1.5a3 3 0 1 0 0-6 3 3 0 1 0 0 6zm4.5 7.875-2.204 1.159.42-2.454-1.782-1.739 2.464-.358L10.5 10.5l1.102 2.233 2.464.358-1.783 1.739.42 2.454-2.203-1.159z"
    />
  </svg>
);

export default SubAccount;
